import { UserSettingsModels } from '@share-models';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { UserSettingsActions } from './user-settings.actions';

export interface UserSettingsState {
  userSettings: UserSettingsModels.UserSettingsDocument;
  isValid: boolean;
  loaded: boolean;
}

export const initialState: UserSettingsState = {
  userSettings: UserSettingsModels.initialUserSettings,
  isValid: false,
  loaded: false,
};

export const userSettingsStateReducer = createReducer(
  initialState,
  on(UserSettingsActions.resetToInitialState, () => ({
    ...initialState,
  })),
  on(UserSettingsActions.setUserSettings, (state, { userSettings }) => ({
    ...state,
    userSettings: {
      ...UserSettingsModels.initialUserSettings,
      ...userSettings,
    },
    loaded: true,
  })),
  on(UserSettingsActions.getMeFail, (state) => ({
    ...state,
    loaded: true,
  })),
);

export const userSettingsFeature = createFeature({
  name: 'userSettings',
  reducer: userSettingsStateReducer,
  extraSelectors: ({ selectUserSettingsState }) => ({
    selectTheme: createSelector(
      selectUserSettingsState,
      ({ userSettings }) => userSettings.theme,
    ),
  }),
});
